import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type CollectionDatum } from 'domains/collections/types/collections.types'

interface Props {
  collection: CollectionDatum
}

export const CollectionsListContentCell: FunctionComponent<Props> = ({ collection }) => {
  const rulesMessage = useDomainMessage('collectionsDomain.list.content.rules', {
    count: collection.subjects?.length,
  })

  const childrenMessage = useDomainMessage('collectionsDomain.list.content.children', {
    count: collection.children?.length,
  })

  const emptyMessage = useDomainMessage('collectionsDomain.list.content.empty')

  if (collection.subjects?.length) {
    return <Text>{rulesMessage}</Text>
  } else if (collection.children?.length) {
    return <Text>{childrenMessage}</Text>
  } else {
    return <Text>{emptyMessage}</Text>
  }
}
